import {EmptyResult, ProjectDataIndex} from '../types';
import {usePost} from '../useHttpHooks';
import {TranslationMode} from './savedTranslations.ts';

export type TranslateCommand = {
    outputId: string;
    language: string;
    text: string | null;
    mixId: string | null;
    dataIndex: ProjectDataIndex | null;
    contentPackageId: string | null;
    mode?: TranslationMode;
    // Files the result so the person can open it again; see savedTranslations.
    pageKey?: string | null;
    title?: string | null;
};

const useTranslate = () =>
    usePost<TranslateCommand, EmptyResult>(`/api/assistant/translate`, {
        errorMessage: 'POST api/assistant/translate failed'
    });

export default useTranslate;
